import { useMemo } from "react";

import { notaDoPapel, obraTitulo } from "../../resolver-conflito.utils";
import type { RevisaoStepProps, RevisaoStepViewModel } from "./types-revisao-step";
import { buildRevisaoGantt, legendaDaRevisao } from "./revisao-step.utils";

/** Etapa Revisão: a troca que será feita, o Gantt dos dois profissionais e a justificativa. */
export function useRevisaoStep({
  profissional,
  alocacao,
  papelRotulo,
  substituto,
  carga,
  periodo,
  today,
  canceladaVisivel,
  simulando,
  disabled,
  justificativa,
}: RevisaoStepProps): RevisaoStepViewModel {
  const { rows, timeline } = useMemo(
    () =>
      buildRevisaoGantt({
        profissional,
        alocacao,
        substituto,
        carga,
        periodo,
        today,
        canceladaVisivel,
      }),
    [profissional, alocacao, substituto, carga, periodo, today, canceladaVisivel],
  );

  return {
    papelRotulo,
    profissionalNome: profissional.nome,
    substitutoNome: substituto.nome,
    obraRotulo: obraTitulo(alocacao.obra),
    notaPapel: notaDoPapel(papelRotulo),
    legenda: legendaDaRevisao(simulando, canceladaVisivel),
    rows,
    timeline,
    today,
    disabled,
    justificativa,
  };
}
